<script>
  /**
   * 远程组件包装器
   * 用于隔离加载远程组件，避免多个远程组件在同一父组件下互相干扰
   *
   * Props:
   *   moduleName - 远程模块名称，如 'flow/FlowHomeFlowNew'
   *
   * Events:
   *   total-change - 透传远程组件的 total-change 事件
   *
   * Methods:
   *   loadData() - 调用远程组件的 loadData 方法
   */
  export default {
    name: 'RemoteWrapper',
    props: {
      moduleName: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        remoteInstance: null
      }
    },
    mounted() {
      this.loadRemote()
    },
    beforeDestroy() {
      if (this.remoteInstance) {
        this.remoteInstance.$destroy()
        this.remoteInstance = null
      }
    },
    methods: {
      loadRemote() {
        const loader = window.__ERP_REMOTE_IMPORT__(this.moduleName)
        if (!loader) return
        new Promise(loader).then(res => {
          const Ctor = this.$options._base.extend(res.default)
          this.remoteInstance = new Ctor({ parent: this })
          this.remoteInstance.$on('total-change', (payload) => {
            this.$emit('total-change', payload)
          })
          this.remoteInstance.$mount()
          this.$el.appendChild(this.remoteInstance.$el)
        }).catch(err => {
          console.error(`[RemoteWrapper] Failed to load module: ${this.moduleName}`, err)
        })
      },
      loadData() {
        this.remoteInstance && this.remoteInstance.loadData()
      }
    },
    render(h) {
      return h('div', { class: 'remote-wrapper' })
    }
  }
</script>

<style scoped>
  .remote-wrapper {
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/layout/pages/home/my-workbench/remote-wrapper.vue